import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";

// Material Dashboard components y context
import MDBox from "../MDBox";
import { useMaterialUIController, setLayout } from "../../../context";

// Íconos
import { Link } from "react-router-dom";
import InstagramIcon from "@mui/icons-material/Instagram";
function DashboardLayout({ children }) {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav } = controller;
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [pathname, dispatch]);

  return (
    <MDBox
      sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
        p: 3,
        position: "relative",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        [breakpoints.up("xl")]: {
          marginLeft: miniSidenav ? pxToRem(120) : pxToRem(274),
          transition: transitions.create(["margin-left", "margin-right"], {
            easing: transitions.easing.easeInOut,
            duration: transitions.duration.standard,
          }),
        },
      })}
    >
      {/* Contenido */}
      <MDBox flexGrow={1}>{children}</MDBox>

      {/* Footer con íconos */}
      <MDBox
        component="footer"
        display="flex"
        justifyContent="center"
        alignItems="center"
        py={2}
        mt={4}
        sx={{
          borderTop: "1px solid #e0e0e0",
          backgroundColor: "#f9f9f9",
        }}
      >
      
      </MDBox>
    </MDBox>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DashboardLayout;
